store.customize = (function() {
	// noinspection JSUnusedLocalSymbols
	var
		$store = $('#store'),
		$buyBox = $store.find('div.buyBox'),
		$form = $buyBox.find('form'),
		$ca = $buyBox.find('.customAttribute'),
		$submitButton = $form.find('#submitCart'),
		dummy = {customization: null}
	;

	function onInitProduct() {
		if ($ca.length < 1) {
			return;
		}
		initFileChange();
		initSubmitButton();
		handleAnyChange();
		initDagatal();
	}

	function onAddToCart(data) {
		if (data.customization) {
			if (data.customization.images) {
				for (var i in data.customization.images) {
					if (data.customization.images.hasOwnProperty(i)) {
						var base = data.customization.images[i];
						if (base) {
							var thumb = findThumbFromBase(base);
							if (thumb) {
								showThumb(i, thumb);
							}
						}
					}
				}
			}
		}
	}

	function findThumbFromBase(base) {
		var thumbBase = base.replace(/(\.jpg)$/, '_thumb$1');
		var thumbFolder = $ca.data('tmpfolder');
		return thumbFolder + '/' + thumbBase;
	}

	function showThumb(key, thumb) {
		var $file = $ca.find('#' + key);
		var $data = $file.parents('.customAttribute__data');
		removeImage($file);
		var $image = $('<div/>').addClass('customAttribute__image');
		var $img = $('<img/>').attr({
			src: thumb,
			alt: 'Image ' + key
		});
		$image.append($img);
		$data.append($image);
		// Don't clear the file element because we need the files to be reUploaded to connect them
	}

	function initFileChange() {
		$ca.find('input[type=file]').change(onFileChange);
	}

	function onFileChange() {
		var $this = $(this);
		var minSize = parseInt($this.data('minsize'));
		if (minSize > 0) {
			if (typeof this.files[0] !== 'undefined') {
				var size = this.files[0].size;
				if (size < minSize) {
					$this.val('');
					fileError($this, 'File to small');
					return;
				}
			}
		}
		if ($this.val()) {
			removeImage($this);
		}
	}

	function fileError($file, msg) {
		if (jQuery.ui) {
			$('<div/>').html(msg).dialog({
				title: 'Error',
				modal: true,
				buttons: {
					'Ok': function () {
						$(this).dialog('close');
						$file.effect('highlight', {}, 3000);
						$file.get(0).focus();
					}
				}
			});
		}
		else {
			alert(msg);
			$file.effect('highlight', {}, 3000);
			$file.get(0).focus();
		}
	}

	function removeImage($file) {
		var $img = $file.parents('.customAttribute__data').find('.customAttribute__image');
		if ($img.length > 0) {
			$img.remove();
		}
	}

	function initSubmitButton() {
		$ca.find(':input').change(handleAnyChange);
		var timer;
		$ca.find('textarea, input[type=text]').keyup(function() {
			if (timer) {
				clearTimeout(timer);
			}
			timer = setTimeout(handleAnyChange, 300);
		});
	}

	function handleAnyChange() {
		var valid = formIsValid();
		if (valid) {
			$submitButton.removeProp('disabled').removeClass('disabled');
		}
		else {
			$submitButton.attr('disabled', 'disabled').addClass('disabled');
		}
	}

	function formIsValid() {
		return store.isFormRequirementsValid($form);
	}

	function initDagatal() {
		var $files = $ca.find('input[type=file]');
		$files.on('dragover', function() {
			$(this).addClass('drop-active');
		}).on('dragleave', function() {
			$(this).removeClass('drop-active');
		}).on('drop', function() {
			$(this).addClass('dropped');
		}).change(function() {
			var $this = $(this);
			$this.removeClass('drop-active');
			if (!$this.val()) {
				$this.removeClass('dropped');
			}
		});
	}
	return {
		onAddToCart: onAddToCart,
		onInitProduct: onInitProduct
	};
})();
